import { z } from "zod";
import { DTOBrandCreatePayload, DTOBrandGetResponse, DTOBrandsListResponse, DTOBrandUpdatePayload } from "../../../dto";
import { RequestExecutor } from "../../../transport/request-executor";

export class BrandsEndpoint {
  constructor(private readonly requestExecutor: RequestExecutor) {}

  get(designSystemId: string, versionId: string, brandId: string) {
    return this.requestExecutor.json(
      `/design-systems/${designSystemId}/versions/${versionId}/brands/${brandId}`,
      DTOBrandGetResponse
    );
  }

  list(designSystemId: string, versionId: string) {
    return this.requestExecutor.json(
      `/design-systems/${designSystemId}/versions/${versionId}/brands`,
      DTOBrandsListResponse
    );
  }

  create(designSystemId: string, versionId: string, body: DTOBrandCreatePayload) {
    return this.requestExecutor.json(
      `/design-systems/${designSystemId}/versions/${versionId}/brands`,
      DTOBrandGetResponse,
      {
        method: "POST",
        body,
      }
    );
  }

  update(dsId: string, vId: string, brandId: string, body: DTOBrandUpdatePayload) {
    return this.requestExecutor.json(`/design-systems/${dsId}/versions/${vId}/brands/${brandId}`, DTOBrandGetResponse, {
      method: "PUT",
      body,
    });
  }

  delete(dsId: string, vId: string, brandId: string) {
    return this.requestExecutor.json(`/design-systems/${dsId}/versions/${vId}/brands/${brandId}`, z.any(), {
      method: "DELETE",
    });
  }
}
